import { createSelector } from 'reselect';

const selectRecommendations = state => state.get('recommendations');

const makeSelectMostVisitedArticles = () =>
  createSelector(selectRecommendations, state => state.get('mostVisitedArticles'));

const makeSelectArticlesRecommendations = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedArticles', 'recommendations']));

const makeSelectArticlesLoading = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedArticles', 'loading']));

const makeSelectArticlesError = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedArticles', 'error']));

const makeSelectArticlesType = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedArticles', 'type']));

const makeSelectMostVisitedProducts = () =>
  createSelector(selectRecommendations, state => state.get('mostVisitedProducts'));

const makeSelectProductsRecommendations = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedProducts', 'recommendations']));

const makeSelectProductsLoading = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedProducts', 'loading']));

const makeSelectProductsError = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedProducts', 'error']));

const makeSelectProductsType = () =>
  createSelector(selectRecommendations, data => data.getIn(['mostVisitedProducts', 'type']));

export {
  selectRecommendations,
  makeSelectMostVisitedArticles,
  makeSelectArticlesRecommendations,
  makeSelectArticlesLoading,
  makeSelectArticlesError,
  makeSelectMostVisitedProducts,
  makeSelectProductsRecommendations,
  makeSelectProductsLoading,
  makeSelectProductsError,
  makeSelectArticlesType,
  makeSelectProductsType,
};
